<div
  *ngIf="shouldRender"
  class="overlay"
  [class.fade-in]="shouldDisplay"
  (click)="onOverlayClicked($event)"
>
  <div
    class="dialog-box"
    [class.fade-in]="shouldDisplay"
    [class.no-scroll]="disableScrolling"
  >
    <ng-template #dialogPlaceholder></ng-template>
    <i2g-icon
      *ngIf="isActiveDialogDismissible"
      class="close-button"
      [icon]="closeIcon"
      i2gTrackable
      [trackingObject]="trackingObject"
      [trackingAction]="closeButtonTrackingAction"
      (click)="onCloseClicked()"
    ></i2g-icon>
  </div>
</div>
